import { Show, onMount } from "solid-js";
import { loadCms } from "../app";
import { Progress } from "../components/progress";
import { createStore } from "solid-js/store";
import { A, useRouteData } from "@solidjs/router";
import { UserSession } from "../types";
import { CMS } from "../components/cms/cms";
import { SectionHeader } from "../components/section-header";
import { PageLoading } from "../components/page-loading";

type State = {
    isContentReady: boolean;
}
export function Complete() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [session, setSession] = createStore<UserSession>({ } as UserSession);
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setSession(routeData.session);
        await loadCms(["24th-arc-scholarship-application/concluded::page-body"])
        setState("isContentReady", true);
    });
    return (
        <>
            <SectionHeader>
                <h1>
                    <CMS id="atelier-application/introduction::page-title">Complete</CMS>
                </h1>
                <p>
                    <a href="/"><CMS text id="nav::home">Home</CMS></a> / <A href="/introduction"><CMS text id="nav::atelier-application">ARC Atelier Application</CMS></A>
                </p>
            </SectionHeader>
            <Show when={state.isContentReady} fallback={<PageLoading />}>
                <section class="landing-page">
                    <div class="marketing">
                        <Progress step={7} />
                        <h1 class="title">
                            Application Complete
                        </h1>
                        <p class="description">
                            Thank you for your application. We will be in touch with you soon.
                        </p>
                        <p class="description">
                            If you have any questions, please contact us at <a href="mailto:staff@artrenewal.org">staff@artrenewal.org</a>.
                        </p>
                    </div>
                </section>
            </Show>
        </>
    );
}